import { render, staticRenderFns } from "./planPage.vue?vue&type=template&id=7bf25156&scoped=true&"
import script from "./planPage.vue?vue&type=script&lang=js&"
export * from "./planPage.vue?vue&type=script&lang=js&"
import style0 from "./planPage.vue?vue&type=style&index=0&id=7bf25156&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf25156",
  null
  
)

export default component.exports